import type {
  AssetDraft,
  AssetStatus,
  AssetType,
  ClientOption,
  ServiceType,
} from "../../types";

export const STATUSES: readonly AssetStatus[] = [
  "Operational",
  "Due Soon",
  "Under Service",
  "Expired",
];

export type ServiceDefinition = {
  key: ServiceType;
  label: string;
};

const LIFE_RAFT_SERVICES: readonly ServiceDefinition[] = [
  { key: "life_raft_service", label: "Life raft service" },
];

const LIFE_BOAT_SERVICES: readonly ServiceDefinition[] = [
  { key: "annual_inspection", label: "Annual inspection" },
  { key: "five_yearly", label: "5 yearly inspection" },
  { key: "refurbishment", label: "Refurbishment" },
  {
    key: "hooks_wire_davit_winch",
    label: "Hooks / wire rope / davit / winch",
  },
];

export function serviceDefinitions(type: AssetType) {
  return type === "Life Raft" ? LIFE_RAFT_SERVICES : LIFE_BOAT_SERVICES;
}

export function createBlankAsset(
  type: AssetType,
  client?: ClientOption,
): AssetDraft {
  return {
    assetId: "",
    type,
    clientId: client?.id ?? "",
    clientCode: client?.code ?? "",
    clientName: client?.name ?? "",
    name: "",
    vessel: "",
    capacity: null,
    unitCount: 1,
    manufacturer: "",
    serial: "",
    imoNumber: "",
    model: "",
    location: "",
    yearOfManufacture: null,
    status: "Operational",
    services: {},
    notes: "",
  };
}
